import { Route, Routes } from 'react-router-dom';

import { DefaultLayout } from 'layouts/DefaultLayout';

import { PDFDownload } from './components/PDFDownload';

export function DownloadsPage(): React.ReactElement {
  return (
    <DefaultLayout isNested>
      <Routes>
        <Route index element={<PDFDownload />} />
      </Routes>
    </DefaultLayout>
  );
}
